import { Component } from '@angular/core';
import {  NavController, NavParams, LoadingController, MenuController } from 'ionic-angular';
import { BuscadorPage } from '../buscador/buscador';
import { OfertaYNoticia } from '../../models/ofertaynoticia.model';
import { Consultas } from '../../providers/consultas';
import { VariablesGlobales } from '../../providers/variables-globales';
import { OfertaPage } from '../oferta/oferta';


@Component({
  selector: 'page-ofertas',
  templateUrl: 'ofertas.html',
  providers: [ Consultas ]
})
export class OfertasPage {
  public ofertas: Array<OfertaYNoticia>;
  public loader: any;
  public idCategoria: number;
  public idCiudad: number;
  public nombrePueblo: string;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public consultas: Consultas,
    public loadingCtrl: LoadingController,
    public global: VariablesGlobales,public menuCtrl:MenuController) {
      this.idCategoria = navParams.get("idCategoria");
      this.idCiudad = navParams.get("idCiudad");
      this.nombrePueblo = navParams.get("nombrePueblo");
  }
  goToBuscar(){
    this.navCtrl.push(BuscadorPage);
  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad OfertasPage');
  }
  ngOnInit(){
    this.loader = this.loadingCtrl.create();
    //Muestro el cargador mientras se cargan los productos
    this.loader.present().then(()=>{
        this.consultas.getOfertas(this.idCiudad,this.idCategoria).subscribe(x=>
          {
            this.ofertas = x;
            this.loader.dismiss();
          },error=>console.error()
          );
    });
  }
  goToOferta(oferta){
    this.navCtrl.push(OfertaPage,{oferta});
  }
  toggleMenu() {
    this.menuCtrl.toggle();
  }
}



// WEBPACK FOOTER //
// ./src/pages/ofertas/ofertas.ts